import { render, staticRenderFns } from "./CoTextArea.vue?vue&type=template&id=57f28422&scoped=true&"
import script from "./CoTextArea.vue?vue&type=script&lang=ts&"
export * from "./CoTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./CoTextArea.vue?vue&type=style&index=0&id=57f28422&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f28422",
  null
  
)

export default component.exports